import { useState } from 'react';
import './GalleryImage.scss';

const GalleryImagePreview = (props: {
  imgUrl: string;
  onDismiss: () => void;
}) => {
  const [ error, setError ] = useState(false);

  return (
    <div className="gallery-image-preview acrylic-translucent" onClick={ () => {
      props.onDismiss();
    } }>
      { error ? <h2>Hiba történt a kép betöltése során</h2> : null }
      <img onClick={ (event) => {
        event.preventDefault(); event.stopPropagation();
      } } id="enlarged-img" style={ {
        visibility: error ? 'collapse' : 'visible'
      } } src={ props.imgUrl } alt=""
        onError={ () => setError(true) } />
    </div>
  );
};

export default GalleryImagePreview;
